import React from 'react';
import { Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { WHITEBG } from 'ui-components/CustomButton';
import GridViewGradientIcon from 'ui-components/GridViewGradientIcon';
import ListViewGradientIcon from 'ui-components/ListViewGradientIcon';
import { useDealFlowView } from 'context/DealFlowViewContext';

/**
 * List ↔ Cards switch for Deal Flow, as a single icon button.
 * The icon shows the view you would switch TO.
 * Both views share the SAME route — this only flips the shell's view state, so
 * the URL stays put and no navigation happens.
 * Renders nothing outside the Deal Flow shell (no provider = no toggle).
 */
const DealFlowViewToggle = () => {
    const ctx = useDealFlowView();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    if (!ctx) return null;
    // Board (cards) view is desktop-only; on phones Deal Flow is list-only, so the
    // toggle is hidden below md. DealFlowShell also forces the list render there, so
    // there's no way to reach — or get stuck on — the board on mobile.
    if (isMobile) return null;
    const { view, setView } = ctx;

    const isList = view === 'list';

    return (
        <Tooltip title={isList ? 'Switch to Cards view' : 'Switch to List view'}>
            {/* Borderless: the icon alone reads as the control, matching the kebab and
                Filter buttons beside it. backgroundImage is neutralised because WHITEBG
                paints a gradient behind the border area. The glyphs are brand-gradient
                SVGs (their own components), matching the gradient Filter icon beside them. */}
            <WHITEBG
                disableRipple
                sx={{
                    border: 'none',
                    backgroundImage: 'none',
                    backgroundColor: 'transparent',
                    minWidth: 'unset',
                    height: '44.5px',
                    px: '3px',
                    py: '6px',
                    '&:hover': { backgroundImage: 'none', backgroundColor: 'transparent' },
                }}
                onClick={() => setView(isList ? 'cards' : 'list')}
            >
                {/* Native art sizes (grid 18x18, list 18x16) so the 1px strokes render
                    exactly as drawn instead of being scaled up. */}
                {isList ? (
                    <GridViewGradientIcon />
                ) : (
                    <ListViewGradientIcon />
                )}
            </WHITEBG>
        </Tooltip>
    );
};

export default DealFlowViewToggle;
